import { InputNumber, Spin, Table, message, notification } from 'antd';
import Link from 'antd/es/typography/Link';
import React, {useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAvailablePOsToMap, updatePOMapping } from '../../store/reducers/orderDashboardSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import CustomButton from '../../components/Buttons/Button';
import { fetchMappedWorkOrders } from '../../store/reducers/poDashboardSlice';

const MapPOContainer = (props: any) => {
    const dispatch = useDispatch();
    const orderDashboardData = useSelector((state: any) => state.orderDashboard);
    const [isMapSectionEnabled, setIsMapSectionEnabled] = React.useState<boolean>(false);
    const [selectedPO, setSelectedPO] = React.useState<any>({});
    const [availablePOs, setAvailablePOs] = React.useState<any[]>([]);
    const [mapValue, setMapValue] = React.useState<string>('');
    const [mappedWorkedOrderList, setMappedWorkedOrderList] = React.useState<any[]>([]);
    const [showWorkOrders, setShowWorkOrders] = React.useState<boolean>(false);
    const [workorderMapDetails, setWorkorderMapDetails] = React.useState<any>({});

    useEffect(() => {
      if(props.isModalOpen && props.activeTab==='1'){
        fetchavailablePOList();
        }

    }, [props.selectedWorkOrder,props.isModalOpen,props.activeTab])

    useEffect(() => {
        if(isMapSectionEnabled){
            dispatch(fetchMappedWorkOrders({poNumber:selectedPO.poNumber}))
            .then(
                (response: any) => {
                if (response.type !== 'po/fetchMappedWorkOrders/fulfilled') {
                    rejectedApiMessage(response.payload);
                }
                else{
                    setMappedWorkedOrderList(response.payload.poMappedToWorkOrderDtoList);
                }
                }
            );
        }
    },[isMapSectionEnabled]);

    useEffect(() => {
        if(!orderDashboardData.poMappingModal.isModalOpen){
          setIsMapSectionEnabled(false); 
          setSelectedPO({});
          setShowWorkOrders(false);
          setWorkorderMapDetails({});
          setMapValue('');
        }
    },[orderDashboardData.poMappingModal.isModalOpen])

    const fetchavailablePOList=()=>{
      dispatch(fetchAvailablePOsToMap({workOrderId:props.selectedWorkOrder.id}))
        .then(
            (response: any) => {
              if (response.type !== 'orderDashboard/fetchAvailablePOsToMap/fulfilled') {
                rejectedApiMessage(response.payload);
              }
              else{
                  setAvailablePOs(response.payload.openToMapPo);
                  setWorkorderMapDetails(response.payload);
              }
            }
          );
    }

    const handleSubmit=()=>{
        console.log("map value",mapValue);
        if(Number(mapValue)<=0){
          message.warning("Map PO value should be greater than 0");
          return;
        }
        const payload: any={};
        payload["workOrderId"] = props.selectedWorkOrder.id;
        payload["poNumber"] = selectedPO.poNumber;
        payload["mappedPoValue"]= mapValue;

        dispatch(updatePOMapping({payloads:payload}))
        .then((response: any) => {
            if (response.type==='orderDashboard/updatePOMapping/fulfilled') {
              console.log('revokeByAdmin response', response);
              notification.success({
                message: 'Success',
                description: 'PO Mapped successfully',
              });
              // props.onPOMappingSuccess();
              fetchavailablePOList();
              setIsMapSectionEnabled(false);
              setShowWorkOrders(false);
              setSelectedPO({});
              setMapValue('');
            } else {
              rejectedApiMessage(response.payload);
            }
          });

    }
    
  return (
    <div>
      <Spin spinning={orderDashboardData.loading} >
        <div>
          <p>
            <b>WorkOrder Id:</b> {props.selectedWorkOrder.id}
          </p>
          <p>
            <b>Total Contract Value:</b> {workorderMapDetails.totalContractValue}
          </p>
          <p>
            <b>Available Contract Value:</b> {workorderMapDetails.avlContractValue || 0}
          </p>
          <p>
            <b>Mapped Contract Value:</b> {workorderMapDetails.mappedContractValue || 0}
          </p>
        </div>
        <Table
          dataSource={availablePOs}
          scroll={{ x: 'max-content', y: '300px'}}
          className='table-style'
          style={{borderRadius:'0px'}}
          columns={[
            {
              title: 'PO Number',
              dataIndex: 'poNumber',
              key: 'poNumber',
              fixed: 'left',
              width: 150,
            },
            {
              title: 'Client Entity',
              dataIndex: 'clientEntity',
              key: 'clientEntity',
              width: 180,
            },
            {
              title: 'Indegene Entity',
              dataIndex: 'indegeneEntity',
              key: 'indegeneEntity',
              width: 180,
            },
            {
              title: 'Currency',
              dataIndex: 'currency',
              key: 'currency',
              width: 100,
            },
            {
              title: 'PO Start Date',
              dataIndex: 'poStartDate',
              key: 'poStartDate',
              width: 150,
            },
            {
              title: 'PO Expiry Date',
              dataIndex: 'poEndDate',
              key: 'poEndDate',
              width: 150,
            },
            {
                title: 'Total PO Value',
                dataIndex: 'totalPoValue',
                key: 'totalPoValue',
                width: 150,
            },
            {
                title: 'Available PO Value',
                dataIndex: 'avlPoValue',
                key: 'avlPoValue',
                width: 180,
                // render: (text: any, record: any) => (<span>{(record.totalPOValue-record.mappedValue).toFixed(2)}</span>)
            },
            {
                title: 'Action',
                dataIndex: 'map',
                key: 'map',
                fixed: 'right',
                width: 100,
                render: (text: any, record: any) => (
                    <> {selectedPO.poNumber === record.poNumber && isMapSectionEnabled?
                        <a className='maplink' onClick={()=>{setIsMapSectionEnabled(false); 
                            setSelectedPO({});
                            setShowWorkOrders(false);
                            setMapValue('');
                        }}>Unmap</a>:
                        <a className='maplink' onClick={()=>{
                            setIsMapSectionEnabled(true); 
                            setSelectedPO(record);
                            setShowWorkOrders(false);
                            setMapValue('');
                        }}>Map</a>}</>)
            }

          ]}
          // loading={userDashboard?.loading}
        />
        {
            isMapSectionEnabled && <div>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', width: 'calc(100% - 20px)', backgroundColor: "#f5f8fa", padding: '10px 0px 10px 0px', color: '#000', margin:'10px' }}><div style={{ font: 'bold 14px / 20px "Nunito Sans"' }}>Purchase Order Mapping Section</div>
                    &nbsp;
                    </div>
                    
                </div>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap',justifyContent:'space-between' }}>
                    <div className='col-lg-4 col-md-4 col-sm-12'>
                        <FloatLabel label="Map PO Value *" value={mapValue}>
                        {/* <Input
                            type='number'
                            min={0}
                            step={1}
                            onKeyDown={handleKeyDown}
                            onWheel={(e) => {
                            const target = e.target as HTMLInputElement;
                            target.blur()
                            }}
                            value={mapValue}
                            id="totalcontractvalue"
                            size='middle'
                            style={{ width: '100%', height: 58, marginRight: '10px',paddingTop:'15px' }}
                            required={true}
                            disabled={false}
                            onChange={(e) =>setMapValue(Number(e.target.value))}
                        /> */}
                        <InputNumber 
                        value={mapValue} 
                        // min={0} 
                        size='middle'
                        style={{ width: '100%', height: 58, marginRight: '10px',paddingTop:'15px' }}
                        onChange={(e:any) =>setMapValue(e)} 
                        // max={selectedPO.totalPOValue-Number(selectedPO.mappedValue)}
                         />
                        </FloatLabel>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-12' style={{display: 'flex', justifyContent: 'end'}}>
                    <Link className='maplink' onClick={()=>setShowWorkOrders(!showWorkOrders)}>{showWorkOrders?"Hide mapped work orders":"View mapped work orders "}</Link>
                    </div>
                </div>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap',margin:'30px 10px 10px 10px ',justifyContent:'flex-end' }}>
                    <CustomButton label="Cancel" type="cancel" onClick={()=>{setIsMapSectionEnabled(false); 
                            setSelectedPO({});
                            setShowWorkOrders(false);
                            setWorkorderMapDetails({});
                            setMapValue('');}} />
                    <CustomButton label="Submit" type="submit" disabled={!mapValue} onClick={()=>handleSubmit()} />
                </div>
                { showWorkOrders && <>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', width: 'calc(100% - 20px)', backgroundColor: "#f5f8fa", padding: '10px 0px 10px 0px', color: '#000', margin:'10px' }}><div style={{ font: 'bold 14px / 20px "Nunito Sans"' }}>Work Orders Mapped to PO #{selectedPO.poNumber}</div>&nbsp;</div>
                </div>
                <Table
                dataSource={mappedWorkedOrderList}
                scroll={{ x: 'max-content' , y: '300px'}}
                
                className='table-style'
                columns={[
                    {
                    title: 'WorkOrder ID',
                    dataIndex: 'workOrderId',
                    key: 'workOrderId',
                    width: 150,
                    },
                    {
                    title: 'Client Entity',
                    dataIndex: 'clientEntity',
                    key: 'clientEntity',
                    width: 150,
                    },
                    {
                    title: 'Indegene Entity',
                    dataIndex: 'indegeneEntity',
                    key: 'indegeneEntity',
                    width: 150,
                    },
                    {
                    title: 'Currency',
                    dataIndex: 'currency',
                    key: 'currency',
                    width: 150,
                    },
                    {
                    title: 'Geography Code',
                    dataIndex: 'geographyName',
                    key: 'geographyName',
                    width: 150,
                    },
                    {
                    title: 'Mapped PO Value',
                    dataIndex: 'mappedPoValue',
                    key: 'mappedPoValue',
                    width: 150,
                    }

                ]}
                // loading={userDashboard?.loading}
                />
                </>
            }

            </div>
        }
        </Spin>
    </div>
  )
}

export default MapPOContainer;